
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/duru-makina",
      function () {
        return require("private-next-pages/about-us/duru-makina.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/duru-makina"])
      });
    }
  